module.exports = __webpack_public_path__ + "static/media/checkingSavings.a8fb4d2f.svg";